import { statsData } from '@/mocks/home';

export default function StatsSection() {
  return (
    <section className="bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {statsData.map((stat) => (
            <div key={stat.id} className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-1">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-primary-100">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}